import { frontendURL } from 'dashboard/helper/URLHelper.js';
import BulkMessagesPage from './BulkMessagesPage.vue';

const bulkMessagesRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/bulk-messages'),
      name: 'bulk_messages_index',
      meta: {
        permissions: ['administrator'],
      },
      component: BulkMessagesPage,
    },
  ],
};

export default bulkMessagesRoutes;
